import { writable } from 'svelte/store';

let siteText            = 'Imobiliária Callegaro';
let siteDescription     = 'Imobiliária em Tramandaí';

export let tagsSEO      = writable('Administração de condomínios, <br /> Aluguel, Compra e Venda de<br /> Imóveis, desde 1991');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

export const ntRent			= writable('-3');
export const ntSeason		= writable('-8');
export const ntSell			= writable('-2');

// E-mails
export const mailAtendimento	= writable("siteatendimento@appimobiliariacallegaro.com.br");
export const mailLocacao		= writable("sitelocacoes@appimobiliariacallegaro.com.br");
export const mailVendas			= writable("sitevendas@appimobiliariacallegaro.com.br");
export const mailOuvidoria		= writable("siteouvidoria@appimobiliariacallegaro.com.br");
export const mailRH				= writable("siterh@appimobiliariacallegaro.com.br");
export const mailLista			= writable("sitelista@appimobiliariacallegaro.com.br");
export const mailAtualize		= writable("siteatendimento@appimobiliariacallegaro.com.br");
export const mailCondominios	= writable("sitecondominio@appimobiliariacallegaro.com.br");

export const textTelefone		= writable("(51) 3661-3821");
export const linkTelefone		= writable("tel://5136613821");

export const textTelefone2		= writable("");
export const linkTelefone2		= writable("");

export const whatsappVendas			= writable("5551985853553");
export const textWhatsappVendas		= writable("(51) 98585-3553");
export const linkWhatsappVendas		= writable("https://wa.me/5551985853553");

export const whatsappLocacao		= writable("5551984189932");
export const textWhatsappLocacao	= writable("(51) 98418-9932");
export const linkWhatsappLocacao	= writable("https://wa.me/5551984189932");

export const whatsappCondominio		= writable("5551985853550");
export const textWhatsappCondominio	= writable("(51) 98585-3550");
export const linkWhatsappCondominio	= writable("https://wa.me/5551985853550");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#nt=-2&tipo_negociacao=-2");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#nt=-3&tipo_negociacao=-3");
export const linkPesquisaTemporada	= writable("/imoveis/temporada#nt=-8&tipo_negociacao=-8");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/paginaimobcallegaro/");
export const linkInstagram      = writable("https://www.instagram.com/imobiliariacallegaro/");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("");

export const linkMapa           = writable("https://goo.gl/maps/tyooCLq9MbazuSKM8");
export const linkWaze           = writable("https://ul.waze.com/ul?place=ChIJ5bcyWiFzGJUR-dPTUXldOZw&ll=-29.99157840%2C-50.13778830&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=W7vPwTVncAp4JEPgdeHDycTF1pXhKKQu&pickup=my_location&dropoff[formatted_address]=Imobili%C3%A1ria%20Callegaro%20-%20Av.%20Rubem%20Berta%20-%20Centro%2C%20Tramanda%C3%AD%20-%20RS%2C%20Brasil&dropoff[latitude]=-29.991578&dropoff[longitude]=-50.137788");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.5773679532927!2d-50.1399769843617!3d-29.99157373578112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951873215a32b7e5%3A0x9c395d7951d3d3f9!2sImobili%C3%A1ria%20Callegaro!5e0!3m2!1spt-BR!2sbr!4v1646420280332!5m2!1spt-BR!2sbr");

export const linkAPI            = writable("https://www.api.com.br");
export const linkAV             = writable("https://appimobiliariacallegaro.com.br/callegaro/");
export const linkConheca        = writable("https://appimobiliariacallegaro.com.br/siteav/");

export const textAtendimento            = writable("De Segunda a Sexta-Feira<br /> das 8h30 às 12h e das 13h30 às 18h,<br />Sábados e feriados,<br />das 9h às 12h e das 14h às 17h.");
export const textEndereco               = writable("Av Rubem Berta, 1629, <br />Centro, Tramandaí - RS");
export const textCNPJ                   = writable("02.073.800/0001-68");
export const textCreci                  = writable("21.905");

export const linkPoliticaPrivacidade	= writable("https://www.imobiliariacallegaro.com.br/privacidade");
export const textPoliticaCheck			= writable("<span style='font-size:12px;font-weight:normal;'>Aceito compartilhar meus dados de acordo com a <a style='text-decoration:underline;' href='https://www.imobiliariacallegaro.com.br/privacidade' target='_blank'>Política de Privacidade</a> da empresa. Estou ciente e concordo em receber todas as comunicações relativas ao meu cadastro, incluindo comunicados, informações e promoções.</span>");